import { Utilities } from '../utilities';
export const questionnaireEvaluationGetSuccessReducer = (state, action) => {
    const getScore = (selectedAction) => {
        if (selectedAction.payload.qstnnreEvalOutcomeList && action.payload.qstnnreEvalOutcomeList.length) {
            if (parseInt(selectedAction.payload.qstnnreEvalOutcomeList[0].score) === 0) {
                return Utilities.convertToLocale('0.00');
            }
            else {
                return Utilities.convertToLocale(selectedAction.payload.qstnnreEvalOutcomeList[0].score);
            }
        }
        else {
            return '';
        }
    };
    return Object.assign(Object.assign({}, state), { questionList: action.payload.resQuestnList, isSaveSuccess: false, overrideScore: action.payload.scoreOverride, scoreData: {
            score: getScore(action),
            comment: action.payload.qstnnreEvalOutcomeList &&
                action.payload.qstnnreEvalOutcomeList.length &&
                action.payload.qstnnreEvalOutcomeList[0].indicator
                ? action.payload.qstnnreEvalOutcomeList[0].indicator
                : ''
        } });
};
//# sourceMappingURL=questionnaireEvaluationGetSuccessReducer.js.map